import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMarkdownComponent } from './simple-icons-markdown.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMarkdownComponent ],
    exports:      [ SimpleIconsMarkdownComponent ],
    bootstrap:    []
})
export class SimpleIconsMarkdownModule {}
